
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/pickyourtrail",
      function () {
        return require("private-next-pages/case-study/pickyourtrail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/pickyourtrail"])
      });
    }
  